import { NavLink } from "react-router-dom";
import {TwoBats, BatBall, List, Stump, Players, Umpire, Stadium} from "../../assets/icons/CricketIcons"
import { ChevronRight } from "lucide-react";

const menu = [
  { label: "Matches", path: "matches", icon: <TwoBats /> },
  { label: "Competitions", path: "competitions", icon: <BatBall /> },
  { label: "Tournaments", path: "tournaments", icon: <List /> },
  { label: "Teams", path: "teams", icon: <Stump /> },
  { label: "Players", path: "players", icon: <Players /> },
  { label: "Umpires", path: "umpires", icon: <Umpire /> },
  { label: "Stadiums", path: "stadiums", icon: <Stadium /> },
];

export default function Sidebar({ forceVisible = false, onItemClick }) {
  // forceVisible=true is used by the tablet-drawer wrapper so the sidebar
  // contents render even on <lg screens (where the inline aside is hidden).
  const containerCls = forceVisible
    ? "w-full h-full"
    : "w-56 border-r bg-bar border-border-default shrink-0 hidden lg:block";
  return (
    <aside className={containerCls}>
      {!forceVisible && (
        <div className="px-6 pt-4 pb-2 border-b border-border-default">
          <div className="text-[10px] uppercase tracking-[0.18em] text-text-secondary">Cricket data</div>
        </div>
      )}
      <nav className="flex flex-col">
        {menu.map((item) => (
          <NavLink
            key={item.path}
            to={`/cricket/${item.path}`}
            onClick={onItemClick}
            className={({ isActive }) =>
              `flex justify-between items-center
              border-l-2 py-3 px-5 text-sm
              transition-all duration-150 ease-in-out
              ${
                isActive
                  ? "bg-button-primary/15 border-button-primary text-text-primary font-semibold"
                  : "border-transparent text-text-secondary hover:text-text-primary hover:bg-bg-secondary/40"
              }`
            }
          >
            <div className="flex gap-3 items-center">
              {item.icon}
              {item.label}
            </div>
            <ChevronRight className="w-4 opacity-60" />
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}